import { useQuery } from '@tanstack/react-query'

import { chatKeys } from '../../keys'
import chatService from '../services'

export function useQueryChatRoom(roomId: string, enabled = true) {
	return useQuery({
		queryKey: chatKeys.room(roomId),
		queryFn: () => chatService.getRoom(roomId),
		enabled: enabled && !!roomId,
	})
}
